import { type CreativesConfig, defaultCreativesConfig } from '@ad-lucy/config/creatives';
import { lazy } from 'react';
import type { componentNames } from './componentNames';

type AaCreativesConfigComponentKeys = (typeof componentNames)[number];

import { CREATIVE_TYPE } from '@ad-lucy/config/creatives';

export const aaConfig: CreativesConfig<AaCreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.AA,
  name: 'Advertorial Ad',
  settings: {
    ...defaultCreativesConfig.settings,
    playVideoIfNotInView: false,
  },
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    mobile: '(max-width: 450px)',
    HPA: '(max-width: 799px)',
    sitebar: '(min-width: 800px)',
  },
  components: {
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
      defaults: {
        ...defaultCreativesConfig.components.closeAd.defaults,
        centered: true,
      },
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    footerLogo: {
      ...defaultCreativesConfig.components.footerLogo,
    },
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    image: {
      ...defaultCreativesConfig.components.image,
      wrapper: lazy(() => import('@ad-lucy/aa/components/styledBuilderComponents/StyledImage')),
    },
    imageAndText: {
      ...defaultCreativesConfig.components.imageAndText,
      wrapper: lazy(() => import('@ad-lucy/aa/components/ImageAndText')),
    },
    link: {
      ...defaultCreativesConfig.components.link,
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
      wrapper: lazy(
        () => import('@ad-lucy/aa/components/styledBuilderComponents/StyledFooterModal'),
      ),
    },
    category: {
      ...defaultCreativesConfig.components.category,
      wrapper: lazy(() => import('@ad-lucy/aa/components/CategoryMenu')),
    },
    slider: {
      ...defaultCreativesConfig.components.slider,
      wrapper: lazy(() => import('@ad-lucy/aa/components/styledBuilderComponents/StyledSlider')),
      settings: {
        ...defaultCreativesConfig.components.slider,
        autoplayOnlyInView: true,
      },
    },
    sliderContainer: {
      ...defaultCreativesConfig.components.sliderContainer,
    },
    socialmedia: {
      ...defaultCreativesConfig.components.socialmedia,
    },
    socialMediaBar: {
      ...defaultCreativesConfig.components.socialMediaBar,
    },
    terms: {
      ...defaultCreativesConfig.components.terms,
    },
    text: {
      ...defaultCreativesConfig.components.text,
      wrapper: lazy(() => import('@ad-lucy/aa/components/Text')),
    },
    viewLater: {
      ...defaultCreativesConfig.components.viewLater,
    },
    video: {
      ...defaultCreativesConfig.components.video,
      wrapper: lazy(() => import('@ad-lucy/aa/components/YouTubeVideo')),
    },
  },
};
